// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import DynamicDropdown, {
    DynamicDropdownPresentationProps,
    OptionObject,
} from "@store/MobiusOverrides/DynamicDropdown/DynamicDropdown";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import constants from "@store/constants";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/Handlers/UpdateDraftParameter";
import {
    useTrailerTrackingV2DataView,
    useTrailerTrackingV2State,
} from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/TrailerTrackingV2Hooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import usePreviousExisting from "@toolkit/Framework/Common/Hooks/usePreviousExisting";
import debounce from "lodash/debounce";
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useFilterDrawerContext } from "@store/Library/Components/FilterDrawerAndButton";

const showAll = "all";

export interface TrailerTrackingV2FilterFieldPlantProps {}

export interface TrailerTrackingV2FilterFieldPlantStyles {
    dynamicDropdown?: DynamicDropdownPresentationProps;
    fieldWrapper?: InjectableCss;
}

export const trailerTrackingV2FilterFieldPlantStyles: TrailerTrackingV2FilterFieldPlantStyles = {
    fieldWrapper: filterDrawerProps.fieldWrapper,
    dynamicDropdown: filterDrawerProps.dynamicDropdown,
};

const styles = trailerTrackingV2FilterFieldPlantStyles;

const TrailerTrackingV2FilterFieldPlant: FC<TrailerTrackingV2FilterFieldPlantProps> = () => {
    const dispatch = useAppDispatch();
    const { scrollElement } = useFilterDrawerContext();
    const { plantCode } = useTrailerTrackingV2State().draftParameter;
    const dataView = useTrailerTrackingV2DataView();
    const previousPlants = usePreviousExisting(dataView.plants);
    const plants = dataView.plants || previousPlants;
    const [options, setOptions] = useState<OptionObject[]>([]);
    const [search, setSearch] = useState("");
    const [filter, setFilter] = useState(search);
    const debouncedSetFilter = useCallback(debounce(setFilter, constants.searchDebounceDelay), []);
    const id = useMemo(uniqueId, []);

    useEffect(() => {
        let options: OptionObject[] = [];
        const lowerCaseFilter = filter.trim().toLowerCase();
        const hasFilter = Boolean(lowerCaseFilter);

        if (plants && plants.length) {
            let filteredPlants = plants;

            if (hasFilter) {
                filteredPlants = plants.filter(x => x.displayName.toLowerCase().includes(lowerCaseFilter));
            }

            options = filteredPlants.map(({ code, displayName }) => ({
                optionText: displayName,
                optionValue: code,
            }));
        }

        if (!hasFilter) {
            options.unshift({
                optionText: translate("Show All Greif Locations"),
                optionValue: showAll,
            });
        }

        setOptions(options);
    }, [filter]);

    return (
        <FilterDrawerSection title={translate("Greif Location")} labelFor={id}>
            <StyledWrapper {...styles.fieldWrapper}>
                <DynamicDropdown
                    {...styles.dynamicDropdown}
                    filterOption={() => true}
                    options={options}
                    onSelectionChange={value => {
                        const plantCode = value === showAll ? "" : value;
                        dispatch(updateDraftParameter({ plantCode }));
                    }}
                    onInputChange={event => {
                        setSearch(event.currentTarget.value);
                        debouncedSetFilter(event.currentTarget.value);
                    }}
                    placeholder={translate("Select Location")}
                    search={search}
                    selected={plantCode || showAll}
                    uid={id}
                    scrollElement={scrollElement}
                />
            </StyledWrapper>
        </FilterDrawerSection>
    );
};

export default TrailerTrackingV2FilterFieldPlant;
